import './plugins/fetch.js';
import './plugins/mixcloud.js';
import { initializeCarousel } from './plugins/carousel.js';

//Scroll To An item
const scrollToElement = function (targetElement) {
   const scrollDistance = targetElement.offset();
   document.querySelector('html').scrollTop(scrollDistance.top - 0);
};

function checkAnimation() {
   var elements = document.querySelectorAll('.blocks__text-image__content__image, .uploads-list__items');
   elements.forEach(function(elem) {
      elements.forEach(function(elem) {
         var rect = elem.getBoundingClientRect();
         var isInViewport = (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth)
         );
         if (isInViewport) {
            elem.classList.add('start-animation');
         }
      });
   });
}

window.addEventListener('scroll', function() {
   checkAnimation();

});

window.addEventListener('touchend', function() {
   checkAnimation();
});

document.addEventListener("DOMContentLoaded", function() {
  const carousels = document.querySelectorAll('.cascade-list');
  carousels.forEach(initializeCarousel);
});


const navIcon = document.querySelector('.nav-main__icon');
const navMenu = document.querySelector('.nav-main__menu');


navIcon.addEventListener('click', function() {
  navMenu.classList.toggle('is-open');
  navIcon.classList.toggle('is-open');
});

